import { withInstall } from '../../utils/install';
import Button from './index.vue';

export const IvueButton = withInstall(Button);
export default IvueButton;

export * from './index.vue';
